<div class="modal-header border  m-2 p-2 pe-3 rounded-3">
  <div class="d-flex align-items-center gap-3">
    <span class="icon text-danger rounded-circle d-inline-flex align-items-center justify-content-center">
      @if (option.icon) {
      <app-icon [name]="getSafeIconName(option.icon || '')" [size]="32" [strokeWidth]="2.2" color="#ce343c"></app-icon>
      }
    </span>
    <h3 class="modal-title h6 mb-0 fw-bold text-wrap">
      {{ option.name }}
    </h3>
  </div>
  <button (click)="cancel()" aria-label="Cerrar" class="btn-close focus-ring focus-ring-light" type="button"></button>
</div>
<div class="modal-body pt-0 px-2">
  <form [formGroup]="form" class="d-flex flex-column gap-2">

    <!-- Currency selection -->
    <app-currency-selector [availableCurrencies]="availableCurrencies" [currencyError]="currencyError"
      [currencyWarning]="currencyWarning" [form]="form">
    </app-currency-selector>

    <!-- Persona que desea asegurar section -->
    <app-primary-insured [form]="form" [occupations]="occupations" [option]="option" [bmiValue]="bmiValue"
      [bmiExceedsMax]="bmiExceedsMax">
      <!-- Children dependents nested inside primary insured card -->
      <app-children-dependents (addChildEvent)="addChild()" (removeChildEvent)="removeChild($event)"
        [childrenArray]="childrenArray" [form]="form" [option]="option">
      </app-children-dependents>
      <!-- Other family dependents nested inside primary insured card -->
      <app-other-dependents (addOtherEvent)="addOther()" (removeOtherEvent)="removeOther($event)"
        [othersArray]="othersArray" [form]="form" [option]="option">
      </app-other-dependents>
    </app-primary-insured>

    @if (hasDurationConstraints) {
    <div class="form-item-card card border form-modal rounded-3">
      <div class="card-header bg-white">
        <div class="fs-6 fw-bold m-0 d-flex gap-2 align-items-center">
          <app-icon [size]="26" [strokeWidth]="2" color="#ce343c" name="calendar"></app-icon>
          Tiempo que deseas tu seguro
        </div>
      </div>
      <div class="card-body pt-2 p-3">
        <div class="row g-3">
          <div class="col-12 col-md-6 col-lg-5">
            <label class="form-label text-uppercase small fw-semibold text-muted d-flex align-items-center gap-1 mb-1">
              ¿Por qué tiempo deseas tu seguro?
              <button #infoButton type="button"
                class="btn btn-sm p-0 btn-outline-light text-muted border-0 rounded-circle" data-bs-toggle="popover"
                data-bs-placement="top" data-bs-custom-class="custom-popover" data-info-title="Duración deseada"
                data-info-content="Tiempo de duración de tu póliza de seguro" (click)="onInfoClick($event)"
                aria-label="Más información sobre duración">
                <app-icon name="info" [size]="18" [strokeWidth]="2" color="#9e9e9e"></app-icon>
              </button>
            </label>
            <div class="form-floating position-relative">
              <input [class.border-danger]="form.get('durationYears')?.touched && (form.get('duration')?.invalid || durationExceedsMaxAge)"
                [class.border-success]="form.get('duration')?.valid && !durationExceedsMaxAge"
                [class.focus-ring-success]="form.get('duration')?.valid && !durationExceedsMaxAge"
                [class.text-danger]="form.get('durationYears')?.touched && (form.get('duration')?.invalid || durationExceedsMaxAge)"
                [placeholder]="(option.durationMin || 1)" class="form-control focus-ring fw-bold"
                formControlName="durationYears" id="insuranceDuration" mask="999" type="text">
              <label class="text-uppercase fw-semibold small" for="insuranceDuration">Duración deseada (Años)</label>
            </div>
            @if (form.get('durationYears')?.touched && (form.get('duration')?.hasError('min') ||
            form.get('duration')?.hasError('max'))) {
            <div class="text-danger small mt-1">
              La duración debe ser entre {{ (option.durationMin || 1) }} e {{ (option.durationMax || 120) }} años
            </div>
            }
            @if (form.get('durationYears')?.touched && form.get('duration')?.hasError('required')) {
            <div class="text-danger small mt-1">
              La duración es obligatoria
            </div>
            }
            @if (form.get('durationYears')?.touched && durationExceedsMaxAge) {
            <div class="text-danger small mt-1">
              La edad al finalizar la duración supera el máximo permitido ({{ durationExceededMaxAgeLimit }} años)
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    }

    <!-- Coberturas -->
    <app-coverage-selector [additionalCoverages]="additionalCoverages" [calculatedCoverages]="calculatedCoverages"
      [coverageError]="coverageError" [form]="form" [getCoverageRange]="getCoverageRange.bind(this)"
      [hasNoPrimaryCoverage]="hasNoPrimaryCoverage" [isEnfermedadesGraves]="isEnfermedadesGraves"
      [primaryCoverage]="primaryCoverage" [insuredCount]="insuredCount" [ageAmountCap]="getAgeAmountCap()"
      [hidden]="isRespaldoColonial || isUltimosGastos">
    </app-coverage-selector>

    <!-- Plan Selection for Enfermedades Graves -->
    @if (isEnfermedadesGraves && option.seriousIllnessPlans?.length) {
    <div class="form-item-card card border form-modal rounded-3">
      <div class="card-header bg-white">
        <div class="fs-6 fw-bold m-0 d-flex gap-2 align-items-center">
          <app-icon [size]="26" [strokeWidth]="2" color="#ce343c" name="gem"></app-icon>
          Selecciona tu Plan
        </div>
      </div>
      <div class="card-body p-3">
        <div class="row g-3">
          @for (plan of option.seriousIllnessPlans; track plan.id) {
          <div class="col-12 col-md-6">
            <label class="plan-card-label w-100 h-100">
              <input [value]="plan.name" class="d-none" formControlName="planOption" type="radio">
              <div [class.bg-danger-subtle]="form.get('planOption')?.value === plan.name"
                [class.border-danger]="form.get('planOption')?.value === plan.name"
                class="card h-100 plan-card border-2 cursor-pointer transition-all">
                <div class="card-body p-3">
                  <div class="d-flex justify-content-between align-items-start">
                    <div>
                      <h5 class="card-title h6 mb-0 fw-bold">Total asegurado: {{ (plan.diagnosisPayout +
                        plan.survivalPayout) | currency : (form.get('currency')?.value === 'USD' ? 'US$' :
                        (form.get('currency')?.value === 'DOP' ? 'RD$' : form.get('currency')?.value)) }}</h5>
                      @if (getPlanPremium(plan) !== null) {
                      <div class="text-muted small">Prima: {{ getPlanPremium(plan) | currency :
                        (form.get('currency')?.value === 'USD' ? 'US$' : (form.get('currency')?.value === 'DOP' ? 'RD$'
                        : form.get('currency')?.value)) }}</div>
                      } @else {
                      <div class="text-muted small fst-italic">Ingrese fecha de nacimiento para ver prima</div>
                      }
                    </div>
                    <div class="d-flex align-items-center gap-1">
                      @if (plan.description) {
                      <button #infoButton type="button"
                        class="btn btn-sm p-0 btn-outline-light text-muted border-0 rounded-circle"
                        data-bs-toggle="popover" data-bs-placement="top" data-bs-custom-class="custom-popover"
                        [attr.data-info-title]="plan.name || ''" [attr.data-info-content]="plan.description || ''"
                        (click)="onInfoClick($event)" [attr.aria-label]="'Más información sobre ' + plan.name">
                        <app-icon name="info" [size]="18" [strokeWidth]="2" color="#9e9e9e"></app-icon>
                      </button>
                      }
                      @if (form.get('planOption')?.value === plan.name) {
                      <app-icon [size]="20" color="#ce343c" name="check-circle"></app-icon>
                      }
                    </div>
                  </div>

                  <!-- Plan Coverages -->
                  @if (plan.coverages?.length) {
                  <div class="small mt-2 pt-2 border-top">
                    @for (cov of plan.coverages; track cov.id) {
                    <div class="d-flex align-items-center gap-1 py-1 border-bottom">
                      <span class="text-muted d-inline-flex align-items-center gap-1">
                        {{ cov.coverageName }}
                        @if (cov.description) {
                        <button #infoButton type="button"
                          class="btn btn-sm p-0 btn-outline-light text-muted border-0 rounded-circle"
                          data-bs-toggle="popover" data-bs-placement="top" data-bs-custom-class="custom-popover"
                          [attr.data-info-title]="cov.coverageName || ''" [attr.data-info-content]="cov.description"
                          (click)="onInfoClick($event)" [attr.aria-label]="'Más información sobre ' + cov.coverageName">
                          <app-icon name="info" [size]="16" [strokeWidth]="2" color="#9e9e9e"></app-icon>
                        </button>
                        }
                      </span>
                    </div>
                    }
                  </div>
                  }
                </div>
              </div>
            </label>
          </div>
          }
        </div>
      </div>
    </div>
    @if (planError) {
    <div class="alert alert-danger d-flex align-items-center gap-2 mt-2 py-2 small fw-semibold" role="alert">
      <app-icon [size]="18" [strokeWidth]="2" name="alert-circle"></app-icon>
      {{ planError }}
    </div>
    }
    }

    <!-- Plan Selection for Respaldo Colonial and Últimos Gastos -->
    @if ((isRespaldoColonial || isUltimosGastos) && option.coveragePlans?.length) {
    <div class="form-item-card card border form-modal rounded-3">
      <div class="card-header bg-white">
        <div class="fs-6 fw-bold m-0 d-flex gap-2 align-items-center">
          <app-icon [size]="26" [strokeWidth]="2" color="#ce343c" name="shield"></app-icon>
          Selecciona tu Plan
        </div>
      </div>
      <div class="card-body p-3">
        <div class="row g-3">
          @for (plan of sortedCoveragePlans; track plan.id) {
          <div class="col-12 col-md-6">
            <label class="plan-card-label w-100 h-100">
              <input [value]="plan.name" class="d-none" formControlName="planOption" type="radio">
              <div [class.bg-danger-subtle]="form.get('planOption')?.value === plan.name"
                [class.border-danger]="form.get('planOption')?.value === plan.name"
                class="card h-100 plan-card border-2 cursor-pointer transition-all">
                <div class="card-body p-3">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <h5 class="card-title h6 mb-0 fw-bold">{{ plan.name }}</h5>
                    @if (form.get('planOption')?.value === plan.name) {
                    <app-icon [size]="20" color="#ce343c" name="check-circle"></app-icon>
                    }
                  </div>
                  <div class="small">
                    <div class="d-flex fw-bold text-muted justify-content-between py-1 border-bottom">
                      <span>Cobertura</span>
                      <span>Límite</span>
                    </div>
                    @for (item of sortedPlanItems(plan); track item.id) {
                    <div class="d-flex justify-content-between py-1 border-bottom">
                      <span class="text-muted d-inline-flex align-items-center gap-1">
                        {{ item.coverageName }}
                        @if (item.description) {
                        <button #infoButton type="button"
                          class="btn btn-sm p-0 btn-outline-light text-muted border-0 rounded-circle"
                          data-bs-toggle="popover" data-bs-placement="top" data-bs-custom-class="custom-popover"
                          [attr.data-info-title]="item.coverageName || ''" [attr.data-info-content]="item.description"
                          (click)="onInfoClick($event)"
                          [attr.aria-label]="'Más información sobre ' + item.coverageName">
                          <app-icon name="info" [size]="16" [strokeWidth]="2" color="#9e9e9e"></app-icon>
                        </button>
                        }

                      </span>
                      <span class="fw-semibold">{{ item.sumInsured | currency : (form.get('currency')?.value === 'USD' ?
                        'US$' : (form.get('currency')?.value === 'DOP' ? 'RD$' : form.get('currency')?.value)) }}</span>
                    </div>
                    }
                    <div class="d-flex justify-content-between pt-2 fw-bold">
                      <span>Prima Anual</span>
                      <span class="text-danger">{{ getPlanTotalPremium(plan) | currency : (form.get('currency')?.value
                        === 'USD' ? 'US$' : (form.get('currency')?.value === 'DOP' ? 'RD$' :
                        form.get('currency')?.value)) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </label>
          </div>
          }
        </div>
      </div>
    </div>
    @if (planError) {
    <div class="alert alert-danger d-flex align-items-center gap-2 mt-2 py-2 small fw-semibold" role="alert">
      <app-icon [size]="18" [strokeWidth]="2" name="alert-circle"></app-icon>
      {{ planError }}
    </div>
    }
    }

    <!-- Health Questionnaire Section -->
    <app-questions-form [class.d-none]="disableQuestions" [categoryQuestions]="categoryQuestions" [form]="form">
    </app-questions-form>

    <!-- Intermediary selection -->
    @if (intermediaryError) {
    <div class="alert alert-danger d-flex align-items-center gap-2 mt-2 py-2 small fw-semibold" role="alert">
      <app-icon [size]="18" [strokeWidth]="2" name="alert-circle"></app-icon>
      {{ intermediaryError }}
    </div>
    }
    <app-producer-selector [form]="form" [producers]="producers">
    </app-producer-selector>

  </form>
</div>
<div class="modal-footer border-0 pb-0 pt-2 justify-content-between">
  @if (selected && canDelete) {
  <button (click)="removeSelected()" class="btn btn-outline-danger rounded-pill" type="button">Eliminar</button>
  }
  <div class="ms-auto d-block">
    <button (click)="cancel()" class="btn btn-outline-secondary rounded-pill me-2" type="button">Cancelar</button>
    <button (click)="save()" class="btn btn-danger rounded-pill" type="button">Continuar</button>
  </div>
</div>
